import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import EmpresasCreate from "./EmpresasCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Baja from "../../Baja";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

function ListadoEmpresas() {
  const { user } = useContext(AuthContext);
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [empresas, setEmpresas] = useState([]);
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);
  const [t, i18n] = useTranslation("global");

  const [idEdit, setIdEdit] = useState()

  useEffect(() => {
    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmpresas = response.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editEmpresa(event) {
    event.preventDefault();
    const URL_EMPRESAS_EDIT = `${process.env.REACT_APP_URL_EMPRESAS}/${idEdit}`;
    axios
      .patch(
        URL_EMPRESAS_EDIT,
        {
          name
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Empresa',
            detalle: name,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, name) {
        setName(name);
        setIdEdit(idEdit);
        toggle();
  }

  return (
    <>
      <Header />
      <div className="container col-sm-11">
        { user.menuEmpresas ? (
          <>
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <span className="page-title-icon"><i className="fas fa-building" /></span>
                {t("Empresas")}
              </h3>
              <p className="page-subtitle">{t("Catálogo de empresas")}</p>
            </div>
          </div>
          <div className="stats-row">
            <div className="stat-chip"><i className="fas fa-list" style={{ color: "#2563eb" }} /> {t("Registros")} <span>{empresas.length}</span></div>
          </div>
          <div className="row">
            {
              <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <Table
                      size="sm"
                      hover
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">{t("Nombre")}</th>
                          <th className="tituloTabla">{t("Editar")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {empresas
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                              return (
                                <tr>
                                  <td className="td-strong">{a.name}</td>
                                  <td>
                                    <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      title={t("Editar")}
                                      onClick={(e) => jalaInfo(a._id, a.name)}
                                    >
                                      <i className="fas fa-edit"></i>{" "}
                                    </Button>

                                    <Baja
                                      idStatus={a._id}
                                      is_active={a.is_active}
                                      URL_BAJA={
                                        process.env.REACT_APP_URL_EMPRESAS
                                      }
                                    />
                              
                                   
                                  </td>
                                </tr>
                              );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            }
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <EmpresasCreate />
                </div>
              </div>
            </div>
          </div>
          </>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{t("Editar")} {t("Empresa")}</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">{t("Nombre")}</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={name}
            required
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editEmpresa}>
            <i className="fas fa-save" /> {t("Guardar")}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoEmpresas;
